import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PropertyListComponent} from './properties/property-list/property-list.component';
import {PropertyEditComponent} from './properties/property-edit/property-edit.component';
import {FormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {InlineSVGModule} from "ng-inline-svg-2";
import {FilterByPipe, NgArrayPipesModule, NgStringPipesModule} from 'ngx-pipes';
import {ActionBarModule} from '../components/action-bar/action-bar.module';
import {PropertyEditModalComponent} from './properties/property-edit-modal/property-edit-modal.component';
import {PropertyEditStateComponent} from './properties/property-edit-state/property-edit-state.component';
import {PropertySelectComponent} from './properties/property-select/property-select.component';
import {PropertyMappingLineEditorComponent} from './property-mappings/property-mapping-line-editor/property-mapping-line-editor.component';
import {ExpressionFormulaComponent} from './property-mappings/expression-formula/expression-formula.component';
import {PropertyLineEditComponent} from './property-mappings/property-line-edit/property-line-edit.component';
import {UnitConversionsEditComponent} from './unit-conversions/unit-conversions-edit/unit-conversions-edit.component';
import {UnitSelectComponent} from './units/unit-select/unit-select.component';
import {UnitEditModalComponent} from './units/unit-edit-modal/unit-edit-modal.component';
import {UnitEditComponent} from './units/unit-edit/unit-edit.component';
import {PropertyLineViewComponent} from './property-mappings/property-line-view/property-line-view.component';
import {CommonSharedModule, HelpModule} from 'common-shared';
import {SystemModule} from '../system/system.module';
import {ClassificatorSelectComponent} from './classificators/classificator-select/classificator-select.component';
import {ClassificatorValueSelectComponent} from './classificators/classificator-value-select/classificator-value-select.component';
import {ClassificatorEditModalComponent} from './classificators/classificator-edit-modal/classificator-edit-modal.component';
import {ClassificatorEditComponent} from './classificators/classificator-edit/classificator-edit.component';
import {RouterModule} from '@angular/router';
import {SelectTextOnFocusDirective} from './select-text-on-focus.directive';
import {NgbDatepickerModule, NgbDropdownModule, NgbNavModule} from '@ng-bootstrap/ng-bootstrap';
import {SortByPropertyPipe} from './properties/sort-by-property.pipe';
import {SpecValueComponent} from './specs/spec-value/spec-value.component';
import {FilterSpecsByGroupPipe} from './specs/filter-specs-by-group.pipe';
import {DateRangeViewComponent} from './date-range-view/date-range-view.component';
import {FilterSpecsBySourcePipe} from './specs/filter-specs-by-source.pipe';
import {AceModule} from 'ngx-ace-wrapper';
import {ExpressionFormulaEditorComponent} from './property-mappings/expression-formula-editor/expression-formula-editor.component';
import {SpecValuesListComponent} from './specs/spec-values-list/spec-values-list.component';
import {SpecLinesViewComponent} from './specs/spec-lines-view/spec-lines-view.component';
import {TranslocoModule} from "@jsverse/transloco";
import {TableModule} from "primeng/table";
import {PropertyUsagesModalComponent} from "./properties/property-usages-modal/property-usages-modal.component";
import {JsonEditorModalComponent} from './json-editor-modal/json-editor-modal.component';
import {CheckboxModule} from 'primeng/checkbox';
import {SpecsByGroupPipe} from './specs/specs-by-group.pipe';
import {ClassificatorListComponent} from "./classificators/classificator-list/classificator-list.component";
import {PropertyListMenuButtonsComponent} from './properties/property-list-menu-buttons/property-list-menu-buttons.component';
import {WebSharedModule} from "../web-shared.module";
import {ParameterListComponent} from './parameters/parameter-list/parameter-list.component';
import {ExpressionFormulaViewComponent} from './property-mappings/expression-formula-view/expression-formula-view.component';
import {FileLinkEditModalComponent} from './specs/file-link-edit-modal/file-link-edit-modal.component';
import {SpecValueViewComponent} from './specs/spec-value-view/spec-value-view.component';
import {SpecLineVisibilityDisplayComponent} from './specs/spec-line-visibility-display/spec-line-visibility-display.component';
import {CopyPasteMenuItemComponent} from "../components/copy-paste-menu-item/copy-paste-menu-item.component";
import {SpecSearchMenuItemComponent} from "./specs/spec-search-menu-item/spec-search-menu-item.component";
import {SpecColumnFilterComponent} from './specs/spec-column-filter/spec-column-filter.component';
import {UserHasPrivilegePipe} from "../system/user/user-has-privilege.pipe";
import {NgOptionHighlightModule} from "@ng-select/ng-option-highlight";
import {JsonEditorComponent} from './json-editor/json-editor.component';
import {HtmlEditorModalComponent} from "./html-editor-modal/html-editor-modal.component";
import {EditorComponent} from "@tinymce/tinymce-angular";

@NgModule({
  imports: [
    AceModule,
    ActionBarModule,
    CheckboxModule,
    CommonModule,
    CommonSharedModule,
    FormsModule,
    HelpModule,
    InlineSVGModule,
    NgArrayPipesModule,
    NgOptionHighlightModule,
    NgSelectModule,
    NgStringPipesModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    NgbNavModule,
    RouterModule,
    SystemModule,
    TableModule,
    TranslocoModule,
    UserHasPrivilegePipe,
    WebSharedModule,
    NgOptionHighlightModule,
    EditorComponent
  ],
  exports: [
    ParameterListComponent,
    PropertySelectComponent,
    PropertyListComponent,
    PropertyEditStateComponent,
    UnitSelectComponent,
    PropertyMappingLineEditorComponent,
    ExpressionFormulaComponent,
    UnitConversionsEditComponent,
    UnitEditModalComponent,
    PropertyLineViewComponent,
    PropertyEditModalComponent,
    ClassificatorListComponent,
    ClassificatorSelectComponent,
    ClassificatorValueSelectComponent,
    SortByPropertyPipe,
    ExpressionFormulaEditorComponent,
    FilterSpecsByGroupPipe,
    DateRangeViewComponent,
    SpecValueComponent,
    FilterSpecsBySourcePipe,
    SpecLinesViewComponent,
    SpecValuesListComponent,
    SpecsByGroupPipe,
    ExpressionFormulaViewComponent,
    JsonEditorModalComponent,
    SpecValueViewComponent,
    SpecLineVisibilityDisplayComponent,
    SpecSearchMenuItemComponent,
    CopyPasteMenuItemComponent,
    SpecColumnFilterComponent,
    JsonEditorComponent,
    HtmlEditorModalComponent
  ],
  declarations: [
    PropertyListComponent,
    PropertyEditComponent,
    PropertyEditModalComponent,
    PropertyEditStateComponent,
    PropertySelectComponent,
    PropertyMappingLineEditorComponent,
    PropertyLineEditComponent,
    ExpressionFormulaComponent,
    UnitConversionsEditComponent,
    UnitSelectComponent,
    UnitEditModalComponent,
    UnitEditComponent,
    PropertyLineViewComponent,
    ClassificatorEditComponent,
    ClassificatorEditModalComponent,
    ClassificatorListComponent,
    ClassificatorSelectComponent,
    ClassificatorValueSelectComponent,
    SelectTextOnFocusDirective,
    SortByPropertyPipe,
    SpecValueComponent,
    FilterSpecsByGroupPipe,
    ExpressionFormulaEditorComponent,
    DateRangeViewComponent,
    FilterSpecsBySourcePipe,
    SpecLinesViewComponent,
    SpecValuesListComponent,
    JsonEditorModalComponent,
    PropertyUsagesModalComponent,
    SpecsByGroupPipe,
    PropertyListMenuButtonsComponent,
    ParameterListComponent,
    ExpressionFormulaViewComponent,
    FileLinkEditModalComponent,
    SpecValueViewComponent,
    SpecLineVisibilityDisplayComponent,
    SpecSearchMenuItemComponent,
    CopyPasteMenuItemComponent,
    SpecColumnFilterComponent,
    JsonEditorComponent,
    HtmlEditorModalComponent
  ],
  providers: [
    FilterByPipe,
    SortByPropertyPipe,
    ClassificatorEditModalComponent,
    ClassificatorSelectComponent,
    ClassificatorValueSelectComponent,
    SelectTextOnFocusDirective,
    SpecValueComponent,
    FilterSpecsByGroupPipe,
    FilterSpecsBySourcePipe,
  ]
})
export class MesCommonModule {
}
